import ErrorText from '@/components/base/form/error-text/error-text';
import FormLabel, {
  type FormLabelProps,
} from '@/components/base/form/form-control/form-label';
import { useErrorMessageTranslator } from '@/components/base/form/form-control/hooks';
import type { ErrorMessageData } from '@/extensions/yup';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';

interface FormControlProps extends Omit<FormLabelProps, 'label'> {
  errorMessage?: string | ErrorMessageData;
  className?: string;
  label?: ReactNode;
  children: ReactNode;
  id?: string;
}

const FormControl = ({
  errorMessage,
  children,
  className,
  label,
  id,
  ...labelProps
}: FormControlProps) => {
  const errorText = useErrorMessageTranslator()(errorMessage);

  return (
    <div
      className={clsx('flex flex-col', className)}
      id={id}
      data-testid="form-control"
    >
      {label && <FormLabel label={label} {...labelProps} />}
      {children}
      {errorText && <ErrorText>{errorText}</ErrorText>}
    </div>
  );
};

export default FormControl;
